import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { useMergedClsPrefix as S } from "../../_mixins/use-config.js";
import j from "./styles/index.cssr.js";
import k from "../../_mixins/use-theme.js";
import L from "../styles/light.js";
import D from "../../tooltip/src/Tooltip.js";
import { defineComponent as $, computed as x, onDeactivated as E, h as p, mergeProps as P } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as f } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
function b(i) {
  return `${i}-ellipsis--line-clamp`;
}
function R(i, s) {
  return `${i}-ellipsis--cursor-${s}`;
}
const B = Object.assign(Object.assign({}, k.props), {
  expandTrigger: String,
  lineClamp: [Number, String],
  tooltip: {
    type: [Boolean, Object],
    default: !0
  }
}), F = $({
  name: "Ellipsis",
  inheritAttrs: !1,
  props: B,
  slots: Object,
  setup(i, {
    slots: s,
    attrs: o
  }) {
    const n = S(), a = k("Ellipsis", "-ellipsis", j, L, i, n), m = f(null), g = f(null), u = f(null), c = f(!1), v = x(() => {
      const {
        lineClamp: e
      } = i, {
        value: t
      } = c;
      return e !== void 0 ? {
        textOverflow: "",
        "-webkit-line-clamp": t ? "" : e
      } : {
        textOverflow: t ? "" : "ellipsis",
        "-webkit-line-clamp": ""
      };
    });
    function C() {
      let e = !1;
      const {
        value: t
      } = c;
      if (t)
        return !0;
      const {
        value: l
      } = m;
      if (l) {
        const {
          lineClamp: r
        } = i;
        if (O(l), r !== void 0)
          e = l.scrollHeight <= l.offsetHeight;
        else {
          const {
            value: T
          } = g;
          T && (e = T.getBoundingClientRect().width <= l.getBoundingClientRect().width);
        }
        w(l, e);
      }
      return e;
    }
    const h = x(() => i.expandTrigger === "click" ? () => {
      var e;
      const {
        value: t
      } = c;
      t && ((e = u.value) === null || e === void 0 || e.setShow(!1)), c.value = !t;
    } : void 0);
    E(() => {
      var e;
      i.tooltip && ((e = u.value) === null || e === void 0 || e.setShow(!1));
    });
    const y = () => p("span", Object.assign({}, P(o, {
      class: [`${n.value}-ellipsis`, i.lineClamp !== void 0 ? b(n.value) : void 0, i.expandTrigger === "click" ? R(n.value, "pointer") : void 0],
      style: v.value
    }), {
      ref: "triggerRef",
      onClick: h.value,
      onMouseenter: (
        // get tooltip disabled will derive cursor style
        i.expandTrigger === "click" ? C : void 0
      )
    }), i.lineClamp ? s : p("span", {
      ref: "triggerInnerRef"
    }, s));
    function O(e) {
      if (!e)
        return;
      const t = v.value, l = b(n.value);
      i.lineClamp !== void 0 ? d(e, l, "add") : d(e, l, "remove");
      for (const r in t)
        e.style[r] !== t[r] && (e.style[r] = t[r]);
    }
    function w(e, t) {
      const l = R(n.value, "pointer");
      i.expandTrigger === "click" && !t ? d(e, l, "add") : d(e, l, "remove");
    }
    function d(e, t, l) {
      l === "add" ? e.classList.contains(t) || e.classList.add(t) : e.classList.contains(t) && e.classList.remove(t);
    }
    return {
      mergedTheme: a,
      triggerRef: m,
      triggerInnerRef: g,
      tooltipRef: u,
      handleClick: h,
      renderTrigger: y,
      getTooltipDisabled: C
    };
  },
  render() {
    var i;
    const {
      tooltip: s,
      renderTrigger: o,
      $slots: n
    } = this;
    if (s) {
      const {
        mergedTheme: a
      } = this;
      return p(D, Object.assign({
        ref: "tooltipRef",
        placement: "top"
      }, s, {
        getDisabled: this.getTooltipDisabled,
        theme: a.peers.Tooltip,
        themeOverrides: a.peerOverrides.Tooltip
      }), {
        trigger: o,
        default: (i = n.tooltip) !== null && i !== void 0 ? i : n.default
      });
    } else
      return o();
  }
});
export {
  R as createCursorClass,
  b as createLineClampClass,
  F as default,
  B as ellipsisProps
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/ellipsis/src/Ellipsis.js
// module id = 484
// module chunks = 67